import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hotlinefilter'
})
export class HotlinefilterPipe implements PipeTransform {

  transform(items: any, filterObj: { [key: string]: any }): any {

    if (!filterObj) {
      return items
    }
    else {
      let date = filterObj.date
      let state = filterObj.state
      if (date != '' && state != '') {
        console.log("filter 1")
         var a =items.filter((item: any) => {
          return item.date == filterObj.date && item.state == filterObj.state
        }
         
        )
        
        return a
      }
      else if (date != '' && state == '') {
          
        var b =items.filter((item: any) => {
         return item.date == filterObj.date
        })
        return b
      }
      else {
       var c= items.filter((item: any) => {
           return item.state == filterObj.state
        })
        return c
      }

    }
  }
}
